export default function (Site, $) {
	Site.widget('form-filter', {
		_create () {
			this.formFilter(),
			this.doAjax()
		},

		formFilter() {
			const filter = this.element;
			const all = filter.find("input.all");

			all.on("change", (e) => {
				if (e.currentTarget.checked) {
					all.attr('checked', true)
					filter.find("input.selector").each( function() {
						if (this.checked === false) {
							this.click()
						}
					})
				} else {
					all.attr('checked', false)
				}
			})

			filter.find("input.selector").on("change", (e) => {
				if (!e.currentTarget.checked) {
					if (all.attr('checked') === 'checked') {
						all.click()
						all.attr('checked', false)
					}
				}

				this.doAjax()
			})
		},

		doAjax() {
			const filter = this.element;
			$.ajax({
                url: 	filter.attr('action'),
                data: 	filter.serialize(),
                type: 	filter.attr('method'),

                beforeSend: (xhr) => {
                    $('#response').fadeOut();
                },
                success: (data) => {
                    $('#response').html(data).fadeIn();
                },
                error: () => {
                    console.log('Silly boy, you\'ve made a terrible mistake!')
                }
			})
		}
	})
}